import { useCallback } from 'react'
import { useOpenViewInSidepanel } from '@renderer/overlay/hooks/use-open-view-in-sidepanel'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import type { ReminderItem } from '../../../hooks/reminder-mapping'
import { useIsReminderLingering } from '../../../hooks/reminder-linger'
import { filterHolding } from '../../reminders-view/reminders-view-order'
import { useStartReminderChat } from '../../../components/reminders/hooks/use-start-reminder-chat'

/** Opens a meeting's reminder in the Reminders view, or starts a chat about it. */
export function useMeetingReminderActions(reminder: ReminderItem, trigger: string) {
  const { openViewInSidepanel } = useOpenViewInSidepanel()
  const startReminderChat = useStartReminderChat()
  const isLingering = useIsReminderLingering(reminder.id)
  const holdingTab = filterHolding(reminder, isLingering)

  const openReminder = useCallback(() => {
    // The tab that actually holds it, rather than whichever one the view
    // remembers: a meeting lists everything it produced, resolved reminders
    // included, and Active filters those out — so the focus would land on a
    // row that isn't in the list.
    openViewInSidepanel('reminders', { initialTab: holdingTab, focusReminderId: reminder.id })
    AmplitudeRenderer.trackEvent('Reminder Action', { type: 'Open', reminderId: reminder.id, trigger })
  }, [openViewInSidepanel, holdingTab, reminder.id, trigger])

  const startChat = useCallback(() => void startReminderChat(reminder, trigger), [startReminderChat, reminder, trigger])

  return { openReminder, startChat }
}
